<template>
  <router-view />
</template>

<style lang="scss">
@import "./sass/table.scss";
.pointer {
  cursor: pointer;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.h-auto {
  height: auto !important;
}

.w-0 {
  width: 0;
}

.w-100 {
  width: 100%;
}

.vertical-align-top {
  vertical-align: top;
}

.align-input-right input {
  text-align: right;
}

.align-input-center >>> input {
  text-align: center;
}

.rotate-0 {
  transform: rotate(0deg);
  transition: rotate 100ms ease-in-out;
}

.rotate-180 {
  transform: rotate(180deg);
  transition: rotate 100ms ease-in-out;
}

.rotate--180 {
  transform: rotate(-180);
  transition: rotate 100ms ease-in-out;
}

.v-icon.v-icon {
  font-size: 1rem !important;
}

.v-card__title {
  word-break: normal !important;
}

.position-relative {
  position: relative;
}

@media (min-width: 1904px) {
  .container {
    max-width: 1500px !important;
  }
}
</style>

<script>
export default {
  name: "App",
  data: () => ({
    //
  })
};
</script>
